import React from 'react'
import { ProductionRouteImport } from './Imports'
const { RoutesMap, ProductionInput, Oee, ProductList, AddProduct, UpdateProduct } = ProductionRouteImport

const ProductionRoute = () => {
    return [
        {
            path: RoutesMap.PRODUCTION_INPUT.path,
            element: <ProductionInput />
        },
        {
            path: RoutesMap.OEE.path,
            element: <Oee />
        },
        {
            path: RoutesMap.PRODUCT_LIST.path,
            element: <ProductList />
        },
        {
            path: RoutesMap.ADD_PRODUCT.path,
            element: <AddProduct />
        },
        {
            path: RoutesMap.UPDATE_PRODUCT.path,
            element: <UpdateProduct />
        },
    ]
}

export default ProductionRoute
